import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=d740b978&scoped=true"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js"
import style0 from "./ReceiptInfo.vue?vue&type=style&index=0&id=d740b978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d740b978",
  null
  
)

export default component.exports